"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontMap = exports.fontMapV1 = exports.fontMapV2 = exports.fontAdjustMap = void 0;
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
exports.fontAdjustMap = {
    g: [0, 1],
    q: [0, 1],
    p: [0, 1],
    y: [0, 1],
    l: [0.5, 0],
    i: [0.5, 0],
};
exports.fontMapV2 = {
    _default: sprites_sidecar_1.sprites.monofont64,
    A: sprites_sidecar_1.sprites.monofontV200,
    B: sprites_sidecar_1.sprites.monofontV201,
    C: sprites_sidecar_1.sprites.monofontV202,
    D: sprites_sidecar_1.sprites.monofontV203,
    E: sprites_sidecar_1.sprites.monofontV204,
    F: sprites_sidecar_1.sprites.monofontV205,
    G: sprites_sidecar_1.sprites.monofontV206,
    H: sprites_sidecar_1.sprites.monofontV207,
    I: sprites_sidecar_1.sprites.monofontV220,
    J: sprites_sidecar_1.sprites.monofontV221,
    K: sprites_sidecar_1.sprites.monofontV222,
    L: sprites_sidecar_1.sprites.monofontV223,
    M: sprites_sidecar_1.sprites.monofontV224,
    N: sprites_sidecar_1.sprites.monofontV225,
    O: sprites_sidecar_1.sprites.monofontV226,
    P: sprites_sidecar_1.sprites.monofontV227,
    Q: sprites_sidecar_1.sprites.monofontV240,
    R: sprites_sidecar_1.sprites.monofontV241,
    S: sprites_sidecar_1.sprites.monofontV242,
    T: sprites_sidecar_1.sprites.monofontV243,
    U: sprites_sidecar_1.sprites.monofontV244,
    V: sprites_sidecar_1.sprites.monofontV245,
    W: sprites_sidecar_1.sprites.monofontV246,
    X: sprites_sidecar_1.sprites.monofontV247,
    Y: sprites_sidecar_1.sprites.monofontV260,
    Z: sprites_sidecar_1.sprites.monofontV261,
    a: sprites_sidecar_1.sprites.monofontV210,
    b: sprites_sidecar_1.sprites.monofontV211,
    c: sprites_sidecar_1.sprites.monofontV212,
    d: sprites_sidecar_1.sprites.monofontV213,
    e: sprites_sidecar_1.sprites.monofontV214,
    f: sprites_sidecar_1.sprites.monofontV215,
    g: sprites_sidecar_1.sprites.monofontV216,
    h: sprites_sidecar_1.sprites.monofontV217,
    i: sprites_sidecar_1.sprites.monofontV230,
    j: sprites_sidecar_1.sprites.monofontV231,
    k: sprites_sidecar_1.sprites.monofontV232,
    l: sprites_sidecar_1.sprites.monofontV233,
    m: sprites_sidecar_1.sprites.monofontV234,
    n: sprites_sidecar_1.sprites.monofontV235,
    o: sprites_sidecar_1.sprites.monofontV236,
    p: sprites_sidecar_1.sprites.monofontV237,
    q: sprites_sidecar_1.sprites.monofontV250,
    r: sprites_sidecar_1.sprites.monofontV251,
    s: sprites_sidecar_1.sprites.monofontV252,
    t: sprites_sidecar_1.sprites.monofontV253,
    u: sprites_sidecar_1.sprites.monofontV254,
    v: sprites_sidecar_1.sprites.monofontV255,
    w: sprites_sidecar_1.sprites.monofontV256,
    x: sprites_sidecar_1.sprites.monofontV257,
    y: sprites_sidecar_1.sprites.monofontV270,
    z: sprites_sidecar_1.sprites.monofontV271,
    '.': sprites_sidecar_1.sprites.monofont62,
    '!': sprites_sidecar_1.sprites.monofont63,
    '?': sprites_sidecar_1.sprites.monofont64,
    ',': sprites_sidecar_1.sprites.monofont65,
    '"': sprites_sidecar_1.sprites.monofont66,
    ':': sprites_sidecar_1.sprites.monofont67,
    ' ': sprites_sidecar_1.sprites.monofont77,
    '#': sprites_sidecar_1.sprites.monofont74,
    '1': sprites_sidecar_1.sprites.monofontNumbers00,
    '2': sprites_sidecar_1.sprites.monofontNumbers01,
    '3': sprites_sidecar_1.sprites.monofontNumbers02,
    '4': sprites_sidecar_1.sprites.monofontNumbers03,
    '5': sprites_sidecar_1.sprites.monofontNumbers10,
    '6': sprites_sidecar_1.sprites.monofontNumbers11,
    '7': sprites_sidecar_1.sprites.monofontNumbers12,
    '8': sprites_sidecar_1.sprites.monofontNumbers13,
    '9': sprites_sidecar_1.sprites.monofontNumbers20,
    '0': sprites_sidecar_1.sprites.monofontNumbers21,
    $: sprites_sidecar_1.sprites.monofontNumbers22,
    '/': sprites_sidecar_1.sprites.monofontNumbers23,
    '\\': sprites_sidecar_1.sprites.monofontSpecial13,
    // '>': sprites.monofontNumbers30,
    '-': sprites_sidecar_1.sprites.monofontNumbers31,
    '+': sprites_sidecar_1.sprites.monofontNumbers32,
    '*': sprites_sidecar_1.sprites.monofontNumbers33,
    '^': sprites_sidecar_1.sprites.monofontSpecial00,
    '(': sprites_sidecar_1.sprites.monofontSpecial01,
    ')': sprites_sidecar_1.sprites.monofontSpecial02,
    "'": sprites_sidecar_1.sprites.monofontSpecial03,
    '@': sprites_sidecar_1.sprites.monofontSpecial10,
    '[': sprites_sidecar_1.sprites.monofontSpecial11,
    ']': sprites_sidecar_1.sprites.monofontSpecial12,
    '%': sprites_sidecar_1.sprites.monofontSpecial20,
    '{': sprites_sidecar_1.sprites.monofontSpecial21,
    '}': sprites_sidecar_1.sprites.monofontSpecial22,
    '|': sprites_sidecar_1.sprites.monofontSpecial30,
    '<': sprites_sidecar_1.sprites.monofontSpecial31,
    '>': sprites_sidecar_1.sprites.monofontSpecial32,
    lineDash: sprites_sidecar_1.sprites.monofontSpecial33,
    back: sprites_sidecar_1.sprites.monofont72,
    back2: sprites_sidecar_1.sprites.monofont73,
};
exports.fontMapV1 = {
    _default: sprites_sidecar_1.sprites.monofont64,
    A: sprites_sidecar_1.sprites.monofont00,
    B: sprites_sidecar_1.sprites.monofont01,
    C: sprites_sidecar_1.sprites.monofont02,
    D: sprites_sidecar_1.sprites.monofont03,
    E: sprites_sidecar_1.sprites.monofont04,
    F: sprites_sidecar_1.sprites.monofont05,
    G: sprites_sidecar_1.sprites.monofont06,
    H: sprites_sidecar_1.sprites.monofont07,
    I: sprites_sidecar_1.sprites.monofont20,
    J: sprites_sidecar_1.sprites.monofont21,
    K: sprites_sidecar_1.sprites.monofont22,
    L: sprites_sidecar_1.sprites.monofont23,
    M: sprites_sidecar_1.sprites.monofont24,
    N: sprites_sidecar_1.sprites.monofont25,
    O: sprites_sidecar_1.sprites.monofont26,
    P: sprites_sidecar_1.sprites.monofont27,
    Q: sprites_sidecar_1.sprites.monofont40,
    R: sprites_sidecar_1.sprites.monofont41,
    S: sprites_sidecar_1.sprites.monofont42,
    T: sprites_sidecar_1.sprites.monofont43,
    U: sprites_sidecar_1.sprites.monofont44,
    V: sprites_sidecar_1.sprites.monofont45,
    W: sprites_sidecar_1.sprites.monofont46,
    X: sprites_sidecar_1.sprites.monofont47,
    Y: sprites_sidecar_1.sprites.monofont60,
    Z: sprites_sidecar_1.sprites.monofont61,
    a: sprites_sidecar_1.sprites.monofont10,
    b: sprites_sidecar_1.sprites.monofont11,
    c: sprites_sidecar_1.sprites.monofont12,
    d: sprites_sidecar_1.sprites.monofont13,
    e: sprites_sidecar_1.sprites.monofont14,
    f: sprites_sidecar_1.sprites.monofont15,
    g: sprites_sidecar_1.sprites.monofont16,
    h: sprites_sidecar_1.sprites.monofont17,
    i: sprites_sidecar_1.sprites.monofont30,
    j: sprites_sidecar_1.sprites.monofont31,
    k: sprites_sidecar_1.sprites.monofont32,
    l: sprites_sidecar_1.sprites.monofont33,
    m: sprites_sidecar_1.sprites.monofont34,
    n: sprites_sidecar_1.sprites.monofont35,
    o: sprites_sidecar_1.sprites.monofont36,
    p: sprites_sidecar_1.sprites.monofont37,
    q: sprites_sidecar_1.sprites.monofont50,
    r: sprites_sidecar_1.sprites.monofont51,
    s: sprites_sidecar_1.sprites.monofont52,
    t: sprites_sidecar_1.sprites.monofont53,
    u: sprites_sidecar_1.sprites.monofont54,
    v: sprites_sidecar_1.sprites.monofont55,
    w: sprites_sidecar_1.sprites.monofont56,
    x: sprites_sidecar_1.sprites.monofont57,
    y: sprites_sidecar_1.sprites.monofont70,
    z: sprites_sidecar_1.sprites.monofont71,
    '.': sprites_sidecar_1.sprites.monofont62,
    '!': sprites_sidecar_1.sprites.monofont63,
    '?': sprites_sidecar_1.sprites.monofont64,
    ',': sprites_sidecar_1.sprites.monofont65,
    '"': sprites_sidecar_1.sprites.monofont66,
    ':': sprites_sidecar_1.sprites.monofont67,
    ' ': sprites_sidecar_1.sprites.monofont77,
    '#': sprites_sidecar_1.sprites.monofont74,
    '1': sprites_sidecar_1.sprites.monofontNumbers00,
    '2': sprites_sidecar_1.sprites.monofontNumbers01,
    '3': sprites_sidecar_1.sprites.monofontNumbers02,
    '4': sprites_sidecar_1.sprites.monofontNumbers03,
    '5': sprites_sidecar_1.sprites.monofontNumbers10,
    '6': sprites_sidecar_1.sprites.monofontNumbers11,
    '7': sprites_sidecar_1.sprites.monofontNumbers12,
    '8': sprites_sidecar_1.sprites.monofontNumbers13,
    '9': sprites_sidecar_1.sprites.monofontNumbers20,
    '0': sprites_sidecar_1.sprites.monofontNumbers21,
    $: sprites_sidecar_1.sprites.monofontNumbers22,
    '/': sprites_sidecar_1.sprites.monofontNumbers23,
    '\\': sprites_sidecar_1.sprites.monofontSpecial13,
    // '>': sprites.monofontNumbers30,
    '-': sprites_sidecar_1.sprites.monofontNumbers31,
    '+': sprites_sidecar_1.sprites.monofontNumbers32,
    '*': sprites_sidecar_1.sprites.monofontNumbers33,
    '^': sprites_sidecar_1.sprites.monofontSpecial00,
    '(': sprites_sidecar_1.sprites.monofontSpecial01,
    ')': sprites_sidecar_1.sprites.monofontSpecial02,
    "'": sprites_sidecar_1.sprites.monofontSpecial03,
    '@': sprites_sidecar_1.sprites.monofontSpecial10,
    '[': sprites_sidecar_1.sprites.monofontSpecial11,
    ']': sprites_sidecar_1.sprites.monofontSpecial12,
    '%': sprites_sidecar_1.sprites.monofontSpecial20,
    '{': sprites_sidecar_1.sprites.monofontSpecial21,
    '}': sprites_sidecar_1.sprites.monofontSpecial22,
    '|': sprites_sidecar_1.sprites.monofontSpecial30,
    '<': sprites_sidecar_1.sprites.monofontSpecial31,
    '>': sprites_sidecar_1.sprites.monofontSpecial32,
    lineDash: sprites_sidecar_1.sprites.monofontSpecial33,
    back: sprites_sidecar_1.sprites.monofont72,
    back2: sprites_sidecar_1.sprites.monofont73,
};
exports.fontMap = exports.fontMapV2;
